module.exports = __webpack_public_path__ + "img/image.d2850ba6.jpg";